import { render, staticRenderFns } from "./TablaAgrupadaReporteMarketing.vue?vue&type=template&id=4bbf0ca7"
import script from "./TablaAgrupadaReporteMarketing.vue?vue&type=script&lang=js"
export * from "./TablaAgrupadaReporteMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports